
export const homePageRoute: string = "/"
export const networkingPageRoute: string = "/networking"
export const myProfilePageRoute: string = "/myprofile"
export const categoriesPageRoute: string = "/categories"
export const infoPageRoute: string = "/info"
export const helpPageRoute: string = "/help"
export const rulesPageRoute: string = "/rules"
export const termsOfUsePageRoute: string = "/termsofuse"
export const testPageRoute: string = "/test"
export const historyPageRoute: string = "/history"
export const pressMediaPageRoute: string = "/press"


/* Details */
export const organizationBackOfficePageRoute: string = "/company/:organizationName--:organizationId/backoffice"
export const organizationDetailPageRoute: string = "/company/:organizationName--:organizationId"
export const personDetailPageRoutePerson: string = "/person/:personName--p-:personId"
export const personDetailPageRouteUser: string = "/person/:personName--u-:userId"
export const eventDateDetailPageRoute: string = "/eventdate/:eventdateName--:eventDateId"
export const productDetailPageRoute: string = "/product/:productName--:productId"
export const newsDetailPageRoute: string = "/news/:newsName--:newsId"
export const trademarkDetailPageRoute: string = "/trademark/:trademarkName--:trademarkId"
export const couponDetailPageRoute: string = "/coupon/:couponName--:couponId"
export const meetingPageRoute: string = "/meeting/:roomName"
export const conferenceGroupPageRoute: string = "/meetings/:groupId"
export const videoRoomPageRoute: string = "/channel/:channelId"

export const conferencePageRoute: string = "/meetings"
export const exhibitorsPageRoute: string = "/organization"
export const liveStreamsPageRoute: string = "/livestreams"
export const productsPageRoute: string = "/product"
export const newsPageRoute: string = "/news"
export const trademarksPageRoute: string = "/trademark"
export const couponsPageRoute: string = "/coupon"
export const sponsorsPageRoute: string = "/sponsor"
export const videoPageRoute: string = "/channels"
export const experiencesPageRoute: string = "/experiences"
export const programPageRoute: string = "/program"
export const schedulePageRoute: string = "/program#schedule"
export const speakersPageRoute: string = "/program#speakers"
export const bookmarkedSpeakersPageRoute: string = "/myspeakers"
export const bookmarkedExhibitorsPageRoute: string = "/myexhibitors"
export const mySchedulePageRoute: string = "/myschedule"


